export default __webpack_public_path__ + "static/media/LastPage1.f6e52b9d.txt";